// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"e0236d3e","361":"f70ad1b2","418":"ab545cf3","653":"8e26a84f","684":"93f90a47","787":"25f4e771"}[chunkId] + ".chunk.js";
};